import "./polyfile"
import React from 'react';
import ReactDOM from 'react-dom';
// import {store} from './store/store.index';
import App from './App';
//import * as serviceWorker from './serviceWorker';
import { message } from 'antd';
import { Provider } from 'mobx-react';
import {store} from './store/index'
import './index.scss';
import { getQueryVariable } from "Utils/utils";
import { loadScript } from "Api/utils/Api.utils";
// import $ from 'jquery'
let isDebug = getQueryVariable('debug');
// message.info('vConsole load serch:'+ location.search)
// function orient() {
//     //alert('gete');
//     if (window.orientation == 0 || window.orientation == 180) {
//         $("body").attr("class", "portrait");
//         orientation = 'portrait';
       
//         return false;
//     }
//     else if (window.orientation == 90 || window.orientation == -90) {
//         $("body").attr("class", "landscape");
//         orientation = 'landscape';

//         return false;
//     }
// }
// $(function(){
//     orient();
// });

// $(window).bind( 'orientationchange', function(e){
//     orient();
// });
if(isDebug && isDebug !== 'none'){
    loadScript('./vconsole.min.js', ()=>{
        var vConsole = new VConsole();
        if(!!vConsole){
            let _console_log = console.log;
            console.log = (...args) => {
                try {
                    _console_log(...args);
                } catch (error) {
                    message.error('vConsole load fail')
                    console.error(error);
                }
            }
            console.info('============= load VConsole successfully... =============')

            //console.log('============= begin to output log=============')
            //console.error('============= begin to output error =============')
        }else{
            message.error('vConsole load fail')
        }
    })
}
//ReactDOM.render(<App />, document.getElementById('root'));
//window._____APP_STATE_____ = store;
//window._____APP_STATE_____['events'] = events;
window.__debug__={};
// babel ... spread syntax https://redux.js.org/recipes/usingobjectspreadoperator  https://www.npmjs.com/package/babel-plugin-transform-object-rest-spread
ReactDOM.render(
	<Provider  {...store} >
        <App />
    </Provider>, 
    document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
//serviceWorker.unregister();
